import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';

@Component({
    selector: 'app-landing-url',
    templateUrl: './landing-url.component.html',
    styleUrls: ['./landing-url.component.scss'],
    standalone: false
})
export class LandingUrlComponent implements OnInit {
  config:any = {};
  private _currentResource: string;
  private _resourceDef: any;
  currentFields: any = {};
  decorator: any;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    private baseService: BaseService,
    private appService: AppService,
    private preferenceService: PreferenceService
  ) { }

  ngOnInit(): void {
    this.config = {
      "submitButton" : true,
      "cancelButton" : true,
      "filterForm" : false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.getUserData();
    this.decorator = this.baseService.initDecorator('LandingUrlDecorator', this.route, this.injector);
    this.baseService.setTitle("Landing Url");
  }
  getUserData() {
    // this.user.currentUser = this.authService.getCurrentUser();
    // console.log('current user', this.user.currentUser);
    this._currentResource = "landing_url";
    this.getResource();

  }
  getResource() {
    this.baseService.init(this._currentResource);
    this.baseService.getResourceDef(this._currentResource, (resourceDef) => {
      if (resourceDef) {
        console.log('resource defination -------------->', resourceDef);
        this._resourceDef = resourceDef;
        this.baseService.getReferredField(resourceDef.form, (response) => {
          this.currentFields['blocks'] = response;
          this.currentFields['submitButton'] = true;
        });
      }
    })
  }
  cancelButtonClick(){
    this.router.navigate([this.appService._currentSessionData.dashboardUrlFound]);
  }
  onSaveFinished(event){
    console.log("Event is ", event);
    this.preferenceService.saveRoleConfigData('landing_url_list_config', this.appService._currentSessionData.roleObj.role, event.result, (res)=>{
      this.appService._currentSessionData.dashboardUrlFound = event.result.landing_url;
      this.appService._currentSessionData.device_type = event.result.device_type;
      this.appService._currentSessionData.device_type_id = event.result.device_type_id;
      this.router.navigate([this.appService._currentSessionData.dashboardUrlFound]);
    });
  }
}
